import { GatewayRuleFieldChip } from 'pages/GatewayRules/components/GatewayRuleField/GatewayRuleFieldChip';
import { ExpressionParam } from 'types/embedded/gatewayRule';

import { GatewayRuleFieldExpressionParamCountry } from './GatewayRuleFieldExpressionParamCountry';
import { GatewayRuleFieldExpressionParamCurrency } from './GatewayRuleFieldExpressionParamCurrency';

type Props = {
  param: ExpressionParam;
  value: string[];
};

export function GatewayRuleFieldExpressionParam({ param, value }: Props): JSX.Element {
  switch (param.alias) {
    case 'currency':
      return <GatewayRuleFieldExpressionParamCurrency codes={value} />;
    case 'country':
      return <GatewayRuleFieldExpressionParamCountry codes={value} />;
    case 'customerId':
      return (
        <>
          {value.map((customerId) => (
            <GatewayRuleFieldChip key={customerId} label={customerId} />
          ))}
        </>
      );
    case 'countDeposit':
      return <GatewayRuleFieldChip label={value} />;
    case 'appVersion':
    case 'domain':
    case 'gatewayPayment':
      return <GatewayRuleFieldChip label={value.length > 1 ? value.join(', ') : value} />;
    default:
      return <></>;
  }
}
